const angular = require('angular')

module.exports = angular
  .module('mw.documents-config', [])
  .directive('mwDocumentsConfig', () => {
    return {
      restrict: 'E',
      scope: false,
      link (scope) {
        scope.$watch('config.updating', (newValue, oldValue) => {
          if (!newValue && oldValue && !scope.config.errored) {
            scope.documents_form.$setPristine()
          }
        })
      },
      template: require('./documents-config.html'),
    }
  })
  .name
